import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"

import id from "@irati/utils/id"

import DealResult from "../../../DealResult/DealResult"
import {DealContextProvider} from "@irati/deals/hooks/useDeal"

const StyledDealResult = styled(DealResult)`
  margin-bottom: 10px;
`

const Deals = (props) => {
  const {results, onClick, maxResultsPerSection} = props

  if (get(results, "data", 0).length === 0) {
    return null
  }

  return results.data.slice(0, maxResultsPerSection).map((deal) => (
    <DealContextProvider deal={deal} key={`wrapper-${deal.uuid}`}>
      <StyledDealResult deal={deal} id={id(`deal__${deal.urlSlug}`, props)} onClick={onClick} />
    </DealContextProvider>
  ))
}

Deals.propTypes = {
  results: PropTypes.shape({data: PropTypes.arrayOf(PropTypes.object)}),
  onClick: PropTypes.func,
  maxResultsPerSection: PropTypes.number,
  searchTerm: PropTypes.string.isRequired
}

Deals.defaultProps = {
  results: {},
  onClick: () => {},
  maxResultsPerSection: 5
}

export default Deals
